import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IRiResearchOrganization } from '@/shared/model/ri-research-organization.model';

const baseApiUrl = 'api/ri-research-organizations';

export default class RiResearchOrganizationService {
  public find(id: number): Promise<IRiResearchOrganization> {
    return new Promise<IRiResearchOrganization>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IRiResearchOrganization): Promise<IRiResearchOrganization> {
    return new Promise<IRiResearchOrganization>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IRiResearchOrganization): Promise<IRiResearchOrganization> {
    return new Promise<IRiResearchOrganization>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public uploadLogoFile(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const formData = new FormData();
      formData.append('file', file);

      axios
        .post('api/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then(res => {
          // Response je: { message: "Uploaded the file successfully: filename.jpg" }
          const message = res.data.message;
          const filename = message.replace('Uploaded the file successfully: ', '');
          resolve(filename);
        })
        .catch(err => reject(err));
    });
  }

  public deleteLogoFile(filename: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`api/delete/document/${filename}`)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public retrieveLogoImage(filename: string): string {
    return `api/retrieve/image/${encodeURIComponent(filename)}`;
  }
}
